import { usePackageHotelShopPage, usePackageHotelShopPageRoute } from "./hooks";
import { PackageHotelShopPage } from "./PackageHotelShopPage";

export const PackageHotelShopPageRoute = () => {
  const search = usePackageHotelShopPageRoute();
  const data = usePackageHotelShopPage({ search });
  return <PackageHotelShopPage {...data} />;
};
